import BaseModelAPI from '../BaseModelAPI';

export default class RoleList extends BaseModelAPI {

	static entity = 'rolelist'
	static entityName = 'role';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
